//@ts-nocheck
import React from 'react';
import { Tooltip, TooltipProps } from 'antd';
import styled from 'styled-components';
import {
  hasVisibleOverlayTitle,
  SuppressScopeButtonLabelTooltip,
} from '@monorepo/shared-lib';

interface CustomTooltipProps extends TooltipProps {
  className?: string;
  children: any;
  restProps: any;
}

const CustomTooltip = React.forwardRef<unknown, CustomTooltipProps>(
  ({ className, children, ...restProps }, ref) => {
    const tooltip = (
      <Tooltip ref={ref} classNames={{ root: className }} {...restProps}>
        {children}
      </Tooltip>
    );

    // Prefer this intentional tooltip over ScopeButton truncation tooltips.
    if (hasVisibleOverlayTitle(restProps.title)) {
      return (
        <SuppressScopeButtonLabelTooltip>
          {tooltip}
        </SuppressScopeButtonLabelTooltip>
      );
    }

    return tooltip;
  }
);

CustomTooltip.displayName = 'CustomTooltip';

export const StyledTooltip = styled(CustomTooltip)<CustomTooltip>`
  .ant-tooltip-arrow {
    display: none;
  }

  .ant-tooltip-inner {
    font-family: Inter !important;
    font-size: ${(props) =>
      props.fontSize ? props.fontSize : '13px'} !important;
    font-weight: 400 !important;
    background-color: var(--color-surface-raised, #ffffff) !important;
    color: var(--color-text-base, #2e2e2e) !important;
    border: 1px solid var(--color-border, #dbeae3);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    width: ${(props) => (props.width ? props.width : 'auto')} !important;
    border-radius: 15px;
    padding: 12px;
  }
`;
